import BaseForm from '../base';
import { LatLongColumnsComponent } from '../components';
export class PumpsForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            new LatLongColumnsComponent({ validate: { required: true } }),
        ];
    }
}
